import React from "react";
import { languages } from "../../constants/languages";
// import bracketPicture from "../../img/bracket.png";
import Typography from "@material-ui/core/Typography";
import EditPouleContainer from "../../containers/structure/EditPouleContainer";
import EditBracketContainer from "../../containers/structure/EditBracketContainer";
import FormatContainer from "../../containers/structure/FormatContainer";

const NoStructureMessage = (props) => (
  <div
    style={{
      width: "95%",
      textAlign: "center",
      marginBottom: 50,
      marginTop: 30,
    }}
  >
    <div style={{ maxWidth: 1000, display: "inline-block" }}>
      {/* <img
        src={bracketPicture}
        alt=""
        style={{ height: 100, margin: "20px 0 15px 0" }}
      /> */}
      <Typography variant="h6">
        {props.divisions.length > 1
          ? languages.structure.noStructureMessageTitleDivision
          : languages.structure.noStructureMessageTitle}
      </Typography>
      <br />
      <br />
      <FormatContainer
        tournament={props.tournament}
        division={props.division}
        tournamentStatus={props.tournamentStatus}
        toggleFinishedDialog={props.toggleFinishedDialog}
      />
      <br />
      <br />
      <Typography variant="subtitle1" style={{ fontSize: 17, marginTop: 10 }}>
        {languages.structure.noStructureMessageDescription}
      </Typography>
      <div style={{ display: "inline-block", margin: "15px 15px 0 15px" }}>
        <EditPouleContainer
          tournament={props.tournament}
          division={props.division}
          poules={props.poules}
          fase={props.fase}
          poulesByKey={props.poulesByKey}
          bracketsByKey={props.bracketsByKey}
          userStatus={props.userStatus}
          tournamentStatus={props.tournamentStatus}
          toggleFinishedDialog={props.toggleFinishedDialog}
          user={props.user || {}}
          toggleUpgradeDialog={props.toggleUpgradeDialog}
        />
      </div>
      <div style={{ display: "inline-block", margin: "15px 15px 0 15px" }}>
        <EditBracketContainer
          tournament={props.tournament}
          division={props.division}
          brackets={props.brackets}
          poules={props.poules}
          fase={props.fase}
          poulesByKey={props.poulesByKey}
          bracketsByKey={props.bracketsByKey}
          userStatus={props.userStatus}
          tournamentStatus={props.tournamentStatus}
          toggleFinishedDialog={props.toggleFinishedDialog}
          toggleUpgradeDialog={props.toggleUpgradeDialog}
          user={props.user || {}}
        />
      </div>
      <div style={{ display: "inline-block", margin: "15px 15px 0 15px" }}>
        <EditPouleContainer
          tournament={props.tournament}
          division={props.division}
          poules={props.poules}
          fase={props.fase}
          singleMatch={true}
          poulesByKey={props.poulesByKey}
          bracketsByKey={props.bracketsByKey}
          userStatus={props.userStatus}
          tournamentStatus={props.tournamentStatus}
          toggleFinishedDialog={props.toggleFinishedDialog}
          user={props.user || {}}
          toggleUpgradeDialog={props.toggleUpgradeDialog}
        />
      </div>
    </div>
  </div>
);

export default NoStructureMessage;
